//import FindSimpleTextBookPopup from "@/pages/comp/book_order/textbook/popup/find_simple";
import TextBookFindSimpleListArea from "@/pages/comp/book_order/textbook/common/find_simple";

function FindSimpleTextBookPopup(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    listOpt: {},
    is_req_order: true,
    xcolumn_show_key_arr: [],
    ...props
  };

  return (
    <div>
      <TextBookFindSimpleListArea
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        callbackData={myProps.callbackData}
        listOpt={myProps.listOpt}
        is_req_order={myProps.is_req_order}
        xcolumn_show_key_arr={myProps.xcolumn_show_key_arr}
      ></TextBookFindSimpleListArea>
    </div>
  );
};
export default FindSimpleTextBookPopup;